import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import ChargeHelper from 'features/Charge/chargeHelper';
import MaintainerHelper from 'features/Maintainer/maintainerHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import KTCheckbox, { KTCheckboxStyle, KTCheckboxType } from 'general/components/OtherKeenComponents/KTFormControls/KTCheckbox';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

DialogAddScheduleMaintenanceView.propTypes = {
    item: PropTypes.object,
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
};

function DialogAddScheduleMaintenanceView({ item, onCancel, onDone }) {
    // MARK: ---- PROPERTIES ----
    const { user } = useSelector((state) => state.auth);
    const agencyRole = user?.role === AppConstants.userRole.agency;
    const [loading, setLoading] = useState(false);
    const [readyToValidate, setReadyToValidate] = useState(false);
    const [selectedChargeStation, setSelectedChargeStation] = useState(null);
    const [selectedChargePoint, setSelectedChargePoint] = useState(null);
    const [startDate, setStartDate] = useState('');
    const [cycle, setCycle] = useState('');
    const [description, setDescription] = useState('');
    const [forAllPoint, setForAllPoint] = useState(false);

    useEffect(() => {
        if (item) {
            setSelectedChargeStation({
                id: item?.chargeStation?.stationId,
                name: item?.chargeStation?.name,
                item: item?.chargeStation,
            });
            setSelectedChargePoint({
                id: item?.pointId,
                name: item?.pointCode,
                item: item,
            });
            setStartDate(item?.maintenanceSchedule?.startDate);
            setCycle(item?.maintenanceSchedule?.cycle);
            setDescription(item?.maintenanceSchedule?.description);
        }
    }, [item]);

    // MARK: ---- FUNCTIONS ----
    const handleSubmit = async () => {
        setReadyToValidate(true);
        if (
            !Utils.isValid(selectedChargeStation) ||
            !Utils.isValid(selectedChargePoint) ||
            !Utils.isValid(startDate) ||
            !Utils.isValid(cycle) ||
            !Utils.isValid(description)
        ) {
            ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
            return;
        }

        setLoading(true);

        let params = {
            stationId: selectedChargeStation?.id ?? '',
            pointId: selectedChargePoint?.id ?? '',
            startDate,
            cycle,
            description,
            forAllPoint,
        };
        params = _.pickBy(params, (value) => value !== null && value !== undefined && value !== '');
        const res = await MaintainerHelper.API.requestCreateMaintenanceSchedule(params);
        if (_.isBoolean(res) && res) {
            AppCustomDialogHelper.show(
                '',
                <AgencySaleDialogView
                    iconEl={<img src={AppResource.images.dialogIcons.dialogAddScheduleSuccess} />}
                    title="Lịch bảo trì đã tạo thành công"
                    contentEl={(
                        <>
                            Lịch bảo trì định kỳ cho trụ sạc đã được tạo thành công. Trụ sạc sẽ được bảo trì vào {' '}
                            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                                {Utils.formatDateTimeToString(startDate, 'DD/MM/YYYY')}
                            </span>
                            , theo chu kỳ {' '}
                            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                                {Utils.formatNumber(cycle)} ngày.
                            </span>
                        </>
                    )}
                    onCancel={() => {
                        onDone && onDone();
                        AppCustomDialogHelper.hide();
                    }}
                    cancelButtonText='Tôi đã hiểu'
                    isShowConfirmButton={false}
                />,
                'md',
                false,
                true
            );
        } else if (_.isString(res)) {
            ToastHelper.showError(res);
        }
        setLoading(false);
    };

    const dropdownChargeStationEl = useMemo(() => {
        return (
            <CustomDropdown2
                id="stationId_dialog"
                name="stationId_dialog"
                ignoreConfirmClick={true}
                toggleElement={
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
                           ${readyToValidate && !Utils.isValid(selectedChargeStation) ? 'button-invalid' : ''}
                           ${!agencyRole ? 'disabled' : ''}
                        `}
                        type="button"
                    >
                        {selectedChargeStation?.name ?? 'Chọn trạm sạc'}
                    </button>
                }
                selectedValue={selectedChargeStation}
                dropdownMenuItems={[{ name: 'Trạm sạc', role: 'STATION' }]}
                getSubItems={async (item) => {
                    try {
                        return await ChargeHelper.API.requestGetChargeStationList(
                            Utils.filterParams({
                                page: item?.page || 0,
                                limit: 10,
                                q: item?.q || '',
                            })
                        ).then((data) => {
                            return {
                                values: data.chargeStations?.map((station) => ({
                                    id: station?.stationId,
                                    name: station?.name,
                                    item: station,
                                })),
                                total: data.total,
                            };
                        });
                    } catch (error) {
                        console.error('Error fetching station list:', error);
                        return { values: [], total: 0 };
                    }
                }}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-100"
                onChange={(value) => {
                    setSelectedChargeStation(value);
                }}
                isDropdownForm={true}
                titleSearchable={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                defaultValue={{
                    name: 'Trạm sạc',
                    role: 'STATION',
                }}
                idCheckType='id'
                footerEl={
                    <div
                        className="p-4 position-sticky sticky-bottom bg-white"
                        style={{
                            borderTop: `1px solid ${AppColors.gray[300]}`,
                        }}
                    >
                        {UIHelper.buildNegativeButton('Bỏ chọn', () => {
                            setSelectedChargeStation(null);
                        })}
                    </div>
                }
                disabled={!agencyRole}
            />
        );
    }, [selectedChargeStation, readyToValidate, agencyRole]);

    const dropdownChargePointEl = useMemo(() => {
        return (
            <CustomDropdown2
                id="pointId_dialog"
                name="pointId_dialog"
                ignoreConfirmClick={true}
                toggleElement={
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
                                ${readyToValidate && !Utils.isValid(selectedChargePoint) ? 'button-invalid' : ''}
                                ${(!agencyRole || !selectedChargeStation?.id) ? 'disabled' : ''}
                            `}
                        type="button"
                    >
                        {selectedChargePoint?.name ?? 'Chọn trụ sạc'}
                    </button>
                }
                selectedValue={selectedChargePoint}
                dropdownMenuItems={[{ name: 'Trụ sạc', role: 'POINT' }]}
                getSubItems={async (item) => {
                    try {
                        console.log({ selectedChargeStation });
                        if (!selectedChargeStation?.id) return;
                        return await ChargeHelper.API.requestGetChargePointList(
                            Utils.filterParams({
                                page: item?.page || 0,
                                limit: 10,
                                q: item?.q || '',
                                stationId: selectedChargeStation?.id,
                            })
                        ).then((data) => {
                            return {
                                values: data.chargePoints?.map((point) => ({
                                    id: point?.pointId,
                                    name: point?.pointCode,
                                    item: point,
                                })),
                                total: data.total,
                            };
                        });
                    } catch (error) {
                        console.error('Error fetching point list:', error);
                        return { values: [], total: 0 };
                    }
                }}
                dependItem={selectedChargeStation}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-100"
                onChange={(value) => {
                    setSelectedChargePoint(value);
                }}
                isDropdownForm={true}
                titleSearchable={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                defaultValue={{
                    name: 'Trụ sạc',
                    role: 'POINT',
                }}
                idCheckType='id'
                footerEl={
                    <div
                        className="p-4 position-sticky sticky-bottom bg-white"
                        style={{
                            borderTop: `1px solid ${AppColors.gray[300]}`,
                        }}
                    >
                        {UIHelper.buildNegativeButton('Bỏ chọn', () => {
                            setSelectedChargeStation(null);
                        })}
                    </div>
                }
                disabled={!agencyRole || !selectedChargeStation?.id}
            />
        );
    }, [selectedChargeStation, selectedChargePoint, readyToValidate, agencyRole]);

    return (
        <div>
            <div className="row m-0 p-0 px-2 mt-4">
                {/* stationId */}
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Trạm sạc', true)}
                    {dropdownChargeStationEl}
                </div>
                {/* pointId */}
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Trụ sạc', true)}
                    {dropdownChargePointEl}
                </div>
                {/* startDate */}
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Ngày bắt đầu', true)}
                    <KTFormInput
                        name="startDate"
                        placeholder="DD/MM/YYYY"
                        type={KTFormInputType.date}
                        value={startDate}
                        onChange={(value) => setStartDate(value)}
                        minTime={moment()}
                        enableCheckValid={readyToValidate}
                        isValid={Utils.isValid(startDate)}
                        isTouched={readyToValidate}
                    />
                </div>
                {/* cycle */}
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Chu kỳ', true)}
                    <KTFormInput
                        name="cycle"
                        placeholder="Nhập số ngày"
                        type={KTFormInputType.number}
                        unit="Ngày"
                        value={cycle}
                        onChange={(value) => setCycle(value)}
                        enableCheckValid={readyToValidate}
                        isValid={Utils.isValid(cycle)}
                        isTouched={readyToValidate}
                    />
                </div>
                {/* description */}
                <div className="col-md-12 mb-4 px-2">
                    {UIHelper.buildFormLabel('Mô tả', true)}
                    <KTFormTextArea
                        placeholder="Nhập mô tả"
                        rows={3}
                        name="description"
                        value={description}
                        onChange={(value) => {
                            setDescription(value);
                        }}
                        enableCheckValid={readyToValidate}
                        isValid={Utils.isValid(description)}
                        isTouched={readyToValidate}
                    />
                </div>
                {/* forAllPoint */}
                <div className="col-md-12 mb-4 px-2">
                    <div className='d-flex gap-2'>
                        <KTCheckbox
                            additionalClassName="checkbox-success"
                            name="forAllPoint"
                            checked={forAllPoint}
                            onChange={(value) => {
                                setForAllPoint(Number(!forAllPoint));
                            }}
                            style={KTCheckboxStyle.rounded}
                            type={KTCheckboxType.default}
                        />
                        <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[800])}>
                            Áp dụng lịch này cho các trụ còn lại thuộc trạm sạc
                        </span>
                    </div>
                </div>
            </div>
            {/* actions */}
            <div
                className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
                {UIHelper.buildGreenButton(
                    !item ? 'Tạo lịch bảo trì' : 'Lưu thiết lập',
                    handleSubmit,
                    null,
                    false,
                    loading
                )}
            </div>
        </div>
    );
}

export default DialogAddScheduleMaintenanceView;
